(function(window, mediaLibModelFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.MediaLibModel = mediaLibModelFactory(window, window.$, window.Q, window.tscml, namespace.TscProjTheme, namespace.playerConfiguration);
})(this, function(window, $, Q, tscml, TscProjTheme, playerConfiguration) {
   'use strict';

   var MediaLibModel = function(tscProjectUriOrObject) {
      var _mediaLibProj = null;
      var _readyDefer = Q.defer();
      var _themeJson;

      var createMediaLibModel = function(mediaLibJson) {
         _mediaLibProj = tscml.Project.createFromJSON(mediaLibJson);

         TscProjTheme.create(_mediaLibProj.themeFile.uri).ready.then(function(themeJson) {
            _themeJson = themeJson;
            _readyDefer.resolve(_mediaLibProj);
         }).catch(function(error) {
            _readyDefer.reject(error);
         });
      };

      var webConnector = playerConfiguration.getWebConnector();
      if (webConnector && typeof tscProjectUriOrObject !== 'object') {
         webConnector.getModule('storage').then(function(storage) {
            storage.loadProject(tscProjectUriOrObject).then(function(response) {
               var tscprojJson;
               if (typeof response.projectFileData === 'string') {
                  try {
                     tscprojJson = JSON.parse(response.projectFileData);
                  } catch (error) {
                     _readyDefer.reject('Media lib - failed to parse project JSON');
                  }
               } else {
                  _readyDefer.reject('Media lib - invalid response loading project');
               }
               createMediaLibModel(tscprojJson);
            });
         });
      } else if (typeof tscProjectUriOrObject === 'object') {
         createMediaLibModel(tscProjectUriOrObject.tscproj);
      } else {
         $.getJSON(tscProjectUriOrObject, createMediaLibModel);
      }

      return Object.defineProperties({}, {
         ready: {
            get: function() {
               return _readyDefer.promise;
            }
         },
         model: {
            get: function() {
               return _mediaLibProj;
            }
         },
         theme: {
            get: function() {
               return _themeJson;
            }
         },
         uri: {
            get: function() {
               return tscProjectUriOrObject;
            }
         }
      });
   };

   return {
      create: MediaLibModel
   };
});
